const shouldDisableServiceWorker = () => {
  if (import.meta.env.DEV) return true;

  const hostname = window.location.hostname;
  return hostname.includes("lovable.app") || hostname.includes("lovableproject.com");
};

const clearServiceWorkerArtifacts = async () => {
  const [registrations, cacheKeys] = await Promise.all([
    navigator.serviceWorker.getRegistrations(),
    typeof caches !== "undefined" ? caches.keys() : Promise.resolve([]),
  ]);

  await Promise.all([
    ...registrations.map((registration) => registration.unregister()),
    ...cacheKeys.map((key) => caches.delete(key)),
  ]);
};

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    if (shouldDisableServiceWorker()) {
      await clearServiceWorkerArtifacts();
      return;
    }

    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => console.log("SW registered:", reg.scope))
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
